export type ParkingProductModel = {
  id?: number;
  pmcId?: number;
  pmcName: string;
  location: string;
  countryCode?: string;
  placeId?: number;
  totalParkingRights?: number;
  totalDelegatedParkingRights?: number;
  totalAssignedParkingRights?: number
  totalPedestrianRights: number;
  totalDelegatedPedestrianRights: number;
  hasUnlimitedEntryRights: boolean;
  contractStartDate?: Date;
  productType: ParkingProductType;
  contractType: ContractType;
};

export enum ParkingProductType  {
  ParkingRights = 1,
  PedestrianAccess = 2,
}

export enum ContractType  {
  SeasonTicket = 1,
  GoBusiness = 2,
}

export type LocatedParkingProductModel = {
  id?: number;
  pmcId?: number;
  pmcName: string;
  location: string;
  countryCode?: string;
  placeId?: number;
  contractStartDate?: Date;
  productType: ParkingProductType
}

export type ResendDelegeeInviteRequest = {
  seasonTicketOwnerCrmId: string;
  registrationId: string;
  email: string;
};
